import { ConfirmDialog } from '@/components/feedback/ConfirmDialog';
import type { LiveCall } from '../types';

interface Props {
  /** Call picked for hang-up; null keeps the dialog closed. */
  call: LiveCall | null;
  busy?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

// Render once per board, outside the table: table cells are rebuilt on every clock
// tick, so state kept inside a cell would be reset. Pair with useLiveCallHangup.
export default function HangupDialog({ call, busy = false, onCancel, onConfirm }: Props) {
  const target = call ? [call.customerName, call.customerNo].filter(Boolean).join(' · ') || 'this call' : '';
  const agent = call?.agent?.name || call?.agent?.ext;

  return (
    <ConfirmDialog
      open={Boolean(call)}
      onOpenChange={(open) => !open && onCancel()}
      title="Hang up this call?"
      description={`This ends the call with ${target}${agent ? ` (agent ${agent})` : ''} for everyone on it. It cannot be undone.`}
      confirmLabel="Hang up"
      tone="destructive"
      loading={busy}
      onConfirm={onConfirm}
    />
  );
}
